import { CommonModule } from "@angular/common";
import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { SharedModule } from "src/app/shared/shared.module";
import { UmovmeEnvironmentDetailsComponent } from "./components/umovme-environment-details/umovme-environment-details.component";
import { UmovmeEnvironmentComponent } from "./components/umovme-environment.component";
import { UmovmeEnvironmentRoutingModule } from "./umovme-environment-routing.module";

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    UmovmeEnvironmentRoutingModule,
    SharedModule,
  ],
  declarations: [UmovmeEnvironmentComponent, UmovmeEnvironmentDetailsComponent],
  exports: [UmovmeEnvironmentComponent, UmovmeEnvironmentDetailsComponent],
  // providers: [UmovmeEnvironmentService],
})
export class UmovmeEnvironmentModule {}
